module.exports = __webpack_public_path__ + "static/media/icon_group_checkbox.fc9239d9.svg";